import * as React from 'react';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';

type Props = {
  notificationText?: string;
  updateIsNotificationBarShown: (shown: boolean) => void;
};

/**
 * Compact notification bar used by legacy screens.
 * Site-wide closeable banner (used for outage / status notices).
 */
const NotificationBar: React.FC<Props> = ({
  notificationText,
  updateIsNotificationBarShown,
}) => {
  if (!notificationText) return null;
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (t) => t.zIndex.snackbar,
      }}
    >
      <Alert
        severity="warning"
        variant="filled"
        action={
          <IconButton
            size="small"
            color="inherit"
            onClick={() => updateIsNotificationBarShown(false)}
            aria-label="close"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        sx={{ borderRadius: 0 }}
      >
        {notificationText}
      </Alert>
    </Box>
  );
};

export default NotificationBar;
